module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content",
    staticStyle: {
      "background-color": "white"
    }
  }, [_c('header', {
    staticClass: "bar bar-nav"
  }, [_c('router-link', {
    staticClass: "button button-link button-nav pull-left",
    attrs: {
      "to": {
        name: 'me'
      }
    }
  }, [_c('span', {
    staticClass: "icon icon-left"
  }), _vm._v("\n      返回\n    ")]), _vm._v(" "), _c('h1', {
    staticClass: "title"
  }, [_vm._v("消息管理 ")])], 1), _vm._v(" "), _c('div', {
    staticClass: "card",
    staticStyle: {
      "margin-top": "3rem"
    }
  }, [_c('div', {
    staticClass: "card-content"
  }, [_c('div', {
    staticClass: "list-block media-list"
  }, _vm._l((_vm.merchantMessages), function(merch, index) {
    return _c('ul', {
      staticStyle: {
        "border-bottom": "1px solid gainsboro",
        "padding-top": "5px"
      }
    }, [_c('a', {
      on: {
        "click": function($event) {
          return _vm.goto(merch)
        }
      }
    }, [_c('li', {
      staticClass: "item-content",
      attrs: {
        "heigh": "20"
      }
    }, [_c('div', {
      staticClass: "item-media",
      style: ({
        'background-image': 'url(' + _vm.url + ') ',
        'padding': '5px',
        'background-size': '100% 100%',
        'width': '2rem',
        'height': '2rem',
        'position': 'relative'
      })
    }, [(merch.unreadMessagesAmount > 0) ? _c('div', {
      staticClass: "tips"
    }, [_vm._v(_vm._s(merch.unreadMessagesAmount))]) : _vm._e()]), _vm._v(" "), _c('div', {
      staticClass: "item-inner",
      staticStyle: {
        "padding": "5px"
      }
    }, [_c('div', {
      staticClass: "item-title-row",
      staticStyle: {
        "font-size": "small"
      }
    }, [_c('div', {
      staticClass: "item-title",
      staticStyle: {
        "color": "black"
      }
    }, [_vm._v("\n                   " + _vm._s(merch.merchantName))]), _vm._v(" "), (merch.lastestMessage.createDT.substring(0, 10) === _vm.date1) ? _c('div', {
      staticStyle: {
        "font-size": "xx-small",
        "color": "gray",
        "float": "right",
        "margin-top": "3px"
      }
    }, [_vm._v(_vm._s(merch.lastestMessage.createDT.substring(11)))]) : _c('div', {
      staticStyle: {
        "font-size": "xx-small",
        "color": "gray",
        "float": "right",
        "margin-top": "3px"
      }
    }, [_vm._v(_vm._s(merch.lastestMessage.createDT.substring(0, 10)))])]), _vm._v(" "), (merch.lastestMessage.message.length > 20) ? _c('div', {
      staticClass: "item-subtitle",
      staticStyle: {
        "color": "gray",
        "font-size": "small"
      }
    }, [_vm._v(_vm._s(merch.lastestMessage.message.substring(0, 15) + '.....'))]) : _c('div', {
      staticClass: "item-subtitle",
      staticStyle: {
        "color": "gray",
        "font-size": "small"
      }
    }, [_vm._v(_vm._s(merch.lastestMessage.message))])])])])])
  }), 0)])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-c7a6b00a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/Message/MessageManagement.vue
// module id = 1722
// module chunks = 8